{
  "es": {
    "cart": {
      "title": "Carrito de compras",
      "lead": "Reúne lo que quieres comprar en el juego y mira dónde conseguirlo. Cada artículo va al lugar más barato que lo vende, salvo que elijas otro.",
      "addToCart": "Añadir al carrito",
      "addLoadout": "Añadir piezas no de serie al carrito",
      "clear": "Vaciar carrito",
      "confirmClear": "¿Quitar todo del carrito?",
      "remove": "Quitar",
      "quantity": "Cantidad",
      "unitPrice": "%{price} c/u",
      "buyElsewhere": "Comprar en otro lugar",
      "cheapest": "Más barato",
      "planPick": "Dejar que el plan elija",
      "pinned": "Tu elección",
      "tripPick": "Elegido para la ruta",
      "unplaced": "Lugar desconocido",
      "totals": {
        "total": "Total",
        "items": "Artículos",
        "stops": "Paradas",
        "unavailable": "No se vende en ningún sitio"
      },
      "unavailable": {
        "title": "No se vende en ningún sitio",
        "text": "Que sepamos, nadie vende esto ahora mismo, así que no cuenta en el total."
      },
      "empty": {
        "title": "Tu carrito está vacío",
        "text": "Añade materias primas, componentes o equipo del catálogo para planificar dónde comprarlos."
      },
      "messages": {
        "added": "%{name} añadido a %{list}.",
        "addFailed": "No se pudo añadir el artículo al carrito.",
        "updateFailed": "No se pudo actualizar el carrito.",
        "accountRequired": "Inicia sesión para usar el carrito de compras.",
        "loadoutAdded": {
          "one": "%{count} pieza añadida a %{list}.",
          "other": "%{count} piezas añadidas a %{list}."
        }
      },
      "lists": {
        "shown": "Lista",
        "create": "Nueva lista",
        "rename": "Renombrar lista",
        "delete": "Eliminar lista",
        "name": "Nombre",
        "activate": "Marcar como activa",
        "isActive": "Lista activa",
        "confirmDelete": "¿Eliminar la lista %{name} y todo lo que contiene?",
        "messages": {
          "saveFailed": "No se pudo guardar la lista."
        }
      },
      "widget": {
        "expand": "Mostrar carrito",
        "collapse": "Ocultar carrito",
        "open": "Abrir carrito",
        "unavailable": "No se vende",
        "more": {
          "one": "+%{count} artículo más",
          "other": "+%{count} artículos más"
        }
      },
      "strategies": {
        "cheapest": {
          "label": "Más barato",
          "hint": "Cada artículo en el lugar más barato que lo vende"
        },
        "stops": {
          "label": "Menos paradas",
          "hint": "Comprar todo en el menor número de lugares, pagando más donde eso ahorra una parada"
        },
        "distance": {
          "label": "Ruta más corta",
          "hint": "Mantener las paradas en los mismos planetas y en el mismo sistema cuando sea posible, pagando más donde eso ahorra viaje"
        }
      },
      "pick": {
        "title": "Añadir %{name} a una lista",
        "hint": {
          "one": "%{count} artículo",
          "other": "%{count} artículos"
        },
        "activeHint": {
          "one": "Lista activa · %{count} artículo",
          "other": "Lista activa · %{count} artículos"
        },
        "loadoutParts": "piezas no de serie",
        "question": "Añadir a:"
      },
      "fleetLists": {
        "title": "Listas de compras",
        "lead": "El equipo que la flota quiere que tengan sus miembros: uniformes, armadura, un equipamiento estándar. Copia una lista a tu carrito para ver cuánto cuesta y dónde comprarlo.",
        "count": {
          "one": "%{count} artículo",
          "other": "%{count} artículos"
        },
        "copy": "Copiar a mi carrito",
        "copyTitle": "Copiar %{name} a",
        "copyNew": "Una lista nueva",
        "copyNewHint": "Con el nombre %{name}, y marcada como tu lista activa",
        "copyIntoHint": {
          "one": "Contiene %{count} artículo; las cantidades se suman",
          "other": "Contiene %{count} artículos; las cantidades se suman"
        },
        "showItems": "Mostrar artículos",
        "hideItems": "Ocultar artículos",
        "edit": "Editar",
        "delete": "Eliminar",
        "publish": "Publicar una lista",
        "publishTitle": "Publicar una de tus listas",
        "editTitle": "Editar lista de compras",
        "source": "Tu lista",
        "sourceHint": "Se copian a la flota sus artículos y cantidades, pero no las tiendas elegidas.",
        "replaceFrom": "Reemplazar artículos con",
        "replaceHint": "Déjalo vacío para mantener los artículos como están.",
        "description": "Descripción",
        "confirmDelete": "¿Eliminar la lista de compras %{name}?",
        "empty": {
          "title": "Aún no hay listas de compras",
          "text": "Los oficiales publican aquí listas desde su propio carrito para que los miembros las copien en el suyo."
        },
        "messages": {
          "copied": "%{name} copiada a %{list}.",
          "copyFailed": "No se pudo copiar la lista a tu carrito.",
          "published": "%{name} publicada.",
          "updated": "%{name} actualizada.",
          "saveFailed": "No se pudo guardar la lista de compras.",
          "deleted": "Lista de compras eliminada.",
          "deleteFailed": "No se pudo eliminar la lista de compras."
        }
      }
    }
  }
}
